<template>
  <div class="event-type-page">
    <div class="filter-box">
      <a-form layout="inline">
        <a-form-item>
          <a-select v-model="form.level" placeholder="请选择级别" allow-clear style="width: 140px">
            <a-select-option v-for="item in levelOptions" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-input v-model="form.system" placeholder="请输入系统" allow-clear />
        </a-form-item>
        <a-form-item>
          <a-input v-model="form.module" placeholder="请输入模块" allow-clear />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="search">查询</a-button>
          <a-button style="margin-left: 10px" @click="reset">重置</a-button>
          <a-button type="primary" style="margin-left: 10px" v-permission="PERMISSIONS.EVENT_TYPE_MANAGE" @click="openCreate">新建事件类型</a-button>
        </a-form-item>
      </a-form>
    </div>

    <vxe-table :border="true" :data="dataSource" :height="tableHeight" resizable :loading="loading">
      <vxe-column field="id" title="ID" width="120" />
      <vxe-column field="code" title="Code" width="120" />
      <vxe-column field="level" title="级别" width="100">
        <template #default="{ row }">
          <a-tag :color="levelTagColor(row.level)">{{ row.level }}</a-tag>
        </template>
      </vxe-column>
      <vxe-column field="system" title="系统" min-width="120" />
      <vxe-column field="module" title="模块" min-width="120" />
      <vxe-column field="description" title="描述" min-width="160" show-overflow="tooltip" />
      <vxe-column field="create_time" title="创建时间" width="160" />
      <vxe-column title="操作" width="140">
        <template #default="{ row }">
          <a-button size="small" v-permission="PERMISSIONS.EVENT_TYPE_MANAGE" @click="openEdit(row)">编辑</a-button>
          <a-button size="small" type="danger" style="margin-left: 8px" v-permission="PERMISSIONS.EVENT_TYPE_MANAGE" @click="handleDelete(row)">删除</a-button>
        </template>
      </vxe-column>
    </vxe-table>

    <div class="pagination-wrapper">
      <a-pagination
        v-model="pagination.current"
        size="small"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        :show-total="total => `共 ${total} 条`"
        @change="pageChange"
      />
    </div>

    <a-modal :title="dialogTitle" :visible="dialogVisible" width="520px" :mask-closable="false" @cancel="handleCancel">
      <a-form :form="modalForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-item label="级别">
          <a-select v-decorator="['level', { rules: [{ required: true, message: '请选择级别' }] }]" placeholder="请选择级别">
            <a-select-option v-for="item in levelOptions" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="系统">
          <a-input v-decorator="['system', { rules: [{ required: true, message: '请输入系统' }] }]" placeholder="请输入系统" />
        </a-form-item>
        <a-form-item label="模块">
          <a-input v-decorator="['module', { rules: [{ required: true, message: '请输入模块' }] }]" placeholder="请输入模块" />
        </a-form-item>
        <a-form-item label="描述">
          <a-textarea v-decorator="['description']" :rows="3" placeholder="请输入描述" />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button @click="handleCancel">取消</a-button>
        <a-button type="primary" :loading="saving" @click="handleSave">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { getEventTypeList, createEventType, updateEventType, deleteEventType } from '@/api/event-type'
import { message, Modal } from 'ant-design-vue'

export default {
  name: 'EventType',
  data() {
    return {
      dataSource: [],
      tableHeight: null,
      loading: false,
      dialogVisible: false,
      saving: false,
      isEdit: false,
      // 弹窗表单实例（antd v-decorator 数据绑定）
      modalForm: this.$form.createForm(this),
      editForm: {
        id: null
      },
      levelOptions: [
        { value: 'debug', label: 'DEBUG' },
        { value: 'info', label: 'INFO' },
        { value: 'warn', label: 'WARN' },
        { value: 'error', label: 'ERROR' },
        { value: 'critial', label: 'CRITICAL' },
        { value: 'fatal', label: 'FATAL' }
      ],
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0
      },
      form: {
        level: undefined,
        system: '',
        module: ''
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑事件类型' : '新建事件类型'
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    this.calcTableHeight()
    window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcTableHeight)
  },
  methods: {
    fetchData() {
      this.loading = true
      const params = {
        page_num: this.pagination.current,
        page_size: this.pagination.pageSize
      }
      if (this.form.level) params.level = this.form.level
      if (this.form.system) params.system = this.form.system
      if (this.form.module) params.module = this.form.module
      getEventTypeList(params)
        .then(res => {
          this.loading = false
          if (res.code === 0) {
            this.dataSource = res.data.list || []
            this.pagination.total = res.data.total || 0
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    search() {
      this.pagination.current = 1
      this.fetchData()
    },
    reset() {
      this.form = { level: undefined, system: '', module: '' }
      this.pagination.current = 1
      this.fetchData()
    },
    pageChange(e) {
      this.pagination.current = e
      this.fetchData()
    },
    openCreate() {
      this.isEdit = false
      this.editForm = { id: null }
      this.dialogVisible = true
      this.$nextTick(() => this.modalForm.resetFields())
    },
    openEdit(row) {
      this.isEdit = true
      this.editForm = { id: row.id }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.modalForm.setFieldsValue({
          level: row.level,
          system: row.system,
          module: row.module,
          description: row.description || ''
        })
      })
    },
    handleCancel() {
      this.dialogVisible = false
    },
    handleSave() {
      this.modalForm.validateFields((err, values) => {
        if (err) return
        this.saving = true
        const data = {
          level: values.level,
          system: values.system,
          module: values.module,
          description: values.description
        }
        const req = this.isEdit ? updateEventType(this.editForm.id, data) : createEventType(data)
        req
          .then(res => {
            this.saving = false
            if (res.code === 0) {
              message.success(this.isEdit ? '更新成功' : '创建成功')
              this.dialogVisible = false
              this.fetchData()
            }
          })
          .catch(() => {
            this.saving = false
          })
      })
    },
    handleDelete(row) {
      Modal.confirm({
        title: '确认删除',
        content: `删除事件类型「${row.module}」会同时删除所有关联的事件日志，确定删除吗？`,
        okText: '确定',
        cancelText: '取消',
        onOk: () => deleteEventType(row.id)
      })
    },
    levelTagColor(level) {
      const map = {
        info: 'green',
        warn: 'orange',
        error: 'red',
        critial: 'red',
        fatal: 'red'
      }
      return map[level]
    },
    calcTableHeight() {
      const pageHeight = window.innerHeight
      const headerHeight = 64
      const contentMargin = 48
      const contentPadding = 48
      const paginationHeight = 52
      const filterBox = document.querySelector('.event-type-page .filter-box')
      const filterHeight = filterBox ? filterBox.clientHeight : 52
      this.tableHeight = pageHeight - headerHeight - contentMargin - contentPadding - filterHeight - paginationHeight
    }
  }
}
</script>

<style scoped>
.event-type-page {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.filter-box {
  margin-bottom: 10px;
  flex-shrink: 0;
}
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  flex-shrink: 0;
}
</style>
